import React from 'react';

import { NavItem } from './environments';

/**
 * Sidebar items for the family console, from the redesign prototype.
 *
 * The icon arrives wrapped in the prototype's tinted `.ic` circle, because
 * that wrapper is what gives each item its colour — the console draws them
 * rose, amber, mint, coral. The educator portal renders the svg bare, which is
 * why the wrapper belongs to the config rather than to the shared nav list.
 *
 * Source: docs/redesign/IQMaxx/1_Parent_Familia.html
 */

export const FAMILY_NAV: NavItem[] = [
  {
    key: 'home',
    label: 'Home',
    to: '/parent/dashboard',
    icon: (
      <span className="ic c-rose">
        <svg viewBox="0 0 24 24">
          <path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" />
        </svg>
      </span>
    ),
  },
  {
    key: 'explore',
    label: 'Explore',
    to: '/parent/explore',
    icon: (
      <span className="ic c-amber">
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </span>
    ),
  },
  {
    key: 'mylearning',
    label: 'My Learning',
    to: '/parent/learning',
    icon: (
      <span className="ic c-rose">
        <svg viewBox="0 0 24 24">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
          <path d="M6 12v5c3 3 9 3 12 0v-5" />
        </svg>
      </span>
    ),
  },
  {
    key: 'pastclasses',
    label: 'Clases pasadas',
    to: '/parent/past-classes',
    icon: (
      <span className="ic c-amber">
        <svg viewBox="0 0 24 24">
          <rect x="3" y="5" width="14" height="14" rx="2" />
          <path d="m17 10 4-2v8l-4-2" />
        </svg>
      </span>
    ),
  },
  {
    key: 'progress',
    label: 'Progress',
    to: '/parent/progress',
    icon: (
      <span className="ic c-mint">
        <svg viewBox="0 0 24 24">
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
          <polyline points="16 7 22 7 22 13" />
        </svg>
      </span>
    ),
  },
  {
    key: 'schedule',
    label: 'Schedule',
    to: '/parent/schedule',
    icon: (
      <span className="ic c-tint">
        <svg viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="18" rx="3" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      </span>
    ),
  },
  {
    key: 'messages',
    label: 'Messages',
    to: '/parent/messages',
    icon: (
      <span className="ic c-coral">
        <svg viewBox="0 0 24 24">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </span>
    ),
  },
  {
    key: 'help',
    label: 'Support',
    to: '/help',
    icon: (
      <span className="ic c-lav">
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="3.2" />
          <line x1="12" y1="2.9" x2="12" y2="8.8" />
          <line x1="12" y1="15.2" x2="12" y2="21.1" />
          <line x1="2.9" y1="12" x2="8.8" y2="12" />
          <line x1="15.2" y1="12" x2="21.1" y2="12" />
        </svg>
      </span>
    ),
  },
];
